import styled, { css } from 'styled-components';
import { th } from 'style/theme';
import { motion } from 'framer-motion';
import { sizes } from 'style';
import Flag from 'components/Flag';

export const AvatarWrapper = styled.div`
  grid-area: avatar;
  background-color: ${th('colors.black')};
  border-radius: 50%;
  width: 80px;
  position: relative;
`;

export const Avatar = styled.div`
  opacity: 0;
  position: absolute;
  left: 0;
  right: 0;
  transition: opacity 1s;
  background-image: url(${({ src }) => src});
  background-size: cover;
  border-radius: 50%;
  width: 100%;
  height: 100%;

  ${({ imageLoaded }) =>
    imageLoaded &&
    css`
      opacity: 1;
    `}

  ${({ hideOnHover, hover }) =>
    hideOnHover &&
    hover &&
    css`
      opacity: 0;
    `}
`;

export const Details = styled.div`
  min-width: 235px;
  width: calc(100% - 95px);
  padding: 8px 0;
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media ${sizes.mobileLarge} {
    padding: 5px 0;
  }
`;

export const Name = styled.p`
  font-weight: 700;
  grid-area: name;
  margin: 0;
  justify-self: start;
  line-height: 20px;
  font-size: 14px;
  transition: color 0.3s;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 90%;

  @media ${sizes.mobileLarge} {
    font-size: 16px;
  }
`;

export const Role = styled.p`
  grid-area: role;
  margin: 0;
  justify-self: start;
  font-size: 14px;
  transition: color 0.3s;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 90%;

  @media ${sizes.mobileLarge} {
    font-size: 16px;
  }
`;

export const Country = styled.p`
  grid-area: country;
  margin: 0;
  color: ${th('colors.turquoise')};
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 90%;
  display: inline-block;
  transition: color 0.3s;

  @media ${sizes.mobileLarge} {
    font-size: 16px;
  }
`;

export const Member = styled(motion.div)`
  height: 80px;
  margin-bottom: 42px;
  width: 100%;
  display: flex;
  cursor: pointer;
  pointer-events: all;

  @media (min-width: 800px) {
    width: 50%;
  }

  @media ${sizes.mediumLargeDesktop} {
    width: 33.33%;
  }

  :hover {
    > ${Details} {
      > ${Name}, ${Role}, ${Country} {
        color: #b2f8f8;
      }
    }
  }
`;

export const StyledFlag = styled(Flag)``;
